function initMap($el, defaultMarkerPosition) {

    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Create generic map.
    var mapArgs = {
        zoom: $el.data('zoom') || 16,
        mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map($el[0], mapArgs);

    // Add markers.
    map.markers = [];
    $markers.each(function () {
        initMarker($(this), map);
    });

    // Center map based on markers or default marker position.
    if (defaultMarkerPosition) {
        map.setCenter(defaultMarkerPosition);
    } else {
        centerMap(map);
    }


    // Return map instance.
    return map;
}

/**
 * initMarker
 *
 * Creates a marker for the given jQuery element and map.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @param   object The map instance.
 * @return  object The marker instance.
 */
function initMarker($marker, map) {

    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
        lat: parseFloat(lat),
        lng: parseFloat(lng)
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
        position: latLng,
        map: map
    });

    // Append to reference for later use.
    map.markers.push(marker);

    // If marker contains HTML, add it to an infoWindow.
    if ($marker.html()) {

        // Create info window.
        var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
        });

        // Show info window when marker is clicked.
        google.maps.event.addListener(marker, 'click', function () {
            infowindow.open(map, marker);
        });
    }
}

function centerMap(map) {

    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    // Case: Single marker.
    if (map.markers.length == 1) {
        map.setCenter(bounds.getCenter());

        // Case: Multiple markers.
    } else {
        map.fitBounds(bounds);
    }
}

// Render maps on page load.
jQuery(document).ready(function () {
    var mapElement = document.querySelector('.mj-single-venue__map');

    if (mapElement) {
        $('.acf-map').each(function () {
            var lat = $('.acf-map .marker').data('lat');
            var lng = $('.acf-map .marker').data('lng');

            // Convert lat and lng to numbers
            lat = Number(lat);
            lng = Number(lng);

            const defaultPosition = { lat: lat, lng: lng };
            var map = initMap($(this), defaultPosition);
        });
    }
});

const CONFIGURATION = {
    "ctaTitle": "Checkout",
    "mapOptions": { "center": { "lat": 37.4221, "lng": -122.0841 }, "fullscreenControl": true, "mapTypeControl": false, "streetViewControl": true, "zoom": 15, "zoomControl": true, "maxZoom": 22, "mapId": "" },
    "mapsApiKey": "AIzaSyAOsEiiK5Fe54ftpAww3tcIv5T-Q457u8k",
    "capabilities": { "addressAutocompleteControl": true, "mapDisplayControl": true, "ctaControl": false }
};

const SHORT_NAME_ADDRESS_COMPONENT_TYPES =
    new Set(['street_number', 'administrative_area_level_1', 'postal_code']);

const ADDRESS_COMPONENT_TYPES_IN_FORM = [
    'location',
    'locality',
    'administrative_area_level_1',
    'postal_code',
    'country',
];

function getFormInputElement(componentType) {
    return document.getElementById(`${componentType}-input`);
}

function fillInAddress(place) {
    function getComponentName(componentType) {
        for (const component of place.address_components || []) {
            if (component.types[0] === componentType) {
                return SHORT_NAME_ADDRESS_COMPONENT_TYPES.has(componentType) ?
                    component.short_name :
                    component.long_name;
            }
        }
        return '';
    }

    function getComponentText(componentType) {
        return (componentType === 'location') ?
            `${getComponentName('street_number')} ${getComponentName('route')}` :
            getComponentName(componentType);
    }

    for (const componentType of ADDRESS_COMPONENT_TYPES_IN_FORM) {
        getFormInputElement(componentType).value = getComponentText(componentType);
    }
}

function renderAddress(place, map, marker) {
    if (place.geometry && place.geometry.location) {
        map.setCenter(place.geometry.location);
        marker.position = place.geometry.location;
    } else {
        marker.position = null;
    }
}

function updateMarkerPositionAndAddress(map, marker, latLng) {
    marker.position = latLng;

    // console.log("Latitude:", latLng.lat());  // Log the latitude
    // console.log("Longitude:", latLng.lng()); // Log the longitude
    document.getElementById('map-latlang').value = latLng.lat() + ',' + latLng.lng();


    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: latLng }, (results, status) => {
        if (status === 'OK') {
            if (results[0]) {
                const place = results[0];
                renderAddress(place, map, marker);
                fillInAddress(place);
            } else {
                window.alert('No results found');
            }
        } else {
            window.alert(`Geocoder failed due to: ${status}`);
        }
    });
}


async function initVenueMap(defaultMarkerPosition) {
    const { Map } = google.maps;
    const { AdvancedMarkerElement } = google.maps.marker;
    const { Autocomplete } = google.maps.places;

    const mapOptions = CONFIGURATION.mapOptions;
    mapOptions.mapId = mapOptions.mapId || 'DEMO_MAP_ID';
    mapOptions.center = defaultMarkerPosition || mapOptions.center || { lat: 37.4221, lng: -122.0841 };
    const map = new Map(document.getElementById('gmp-map'), mapOptions);

    // const marker = new AdvancedMarkerElement({ map }); // Marker creation after setting center
    // Create marker with position set to defaultMarkerPosition
    const marker = new AdvancedMarkerElement({
        position: defaultMarkerPosition,
        map: map,
    });
    const autocomplete = new Autocomplete(getFormInputElement('location'), {
        fields: ['address_components', 'geometry', 'name'],
    });

    autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        if (!place.geometry) {
            window.alert(`No details available for input: '${place.name}'`);
            return;
        }

        // Extracting latitude and longitude
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();

        console.log("Latitude:", lat);
        console.log("Longitude:", lng);
        updateMarkerPositionAndAddress(map, marker, new google.maps.LatLng(lat, lng));

        renderAddress(place, map, marker);
        fillInAddress(place);
    });

    map.addListener('click', (event) => {
        const clickedLatLng = event.latLng;
        console.log(clickedLatLng);
        updateMarkerPositionAndAddress(map, marker, clickedLatLng);
    });
}
